import React from 'react';

const ConfLoader = () => (
    <div role='main' id='on-conf-loader' className='preload' aria-busy='true' />
);

export default ConfLoader;
